// src/components/HousingHistoryTable.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { ApplicationHousingEntryDto } from "../../api/services";
import { formatDate } from "@ui/shared";

interface Props {
  entries: ApplicationHousingEntryDto[];
  onEdit: (entry: ApplicationHousingEntryDto) => void;
  onDelete: (entry: ApplicationHousingEntryDto) => void;
}

const HousingHistoryTable: React.FC<Props> = ({
  entries,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <table className="w-full text-sm">
      <thead className="border-b border-gray-200">
        <tr>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("housingHistoryTable.address")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("housingHistoryTable.moveIn")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("housingHistoryTable.moveOut")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("housingHistoryTable.manager")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("housingHistoryTable.phone")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("housingHistoryTable.email")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted"></th>
        </tr>
      </thead>
      <tbody>
        {entries.map((e) => (
          <tr key={e.id}>
            <td className="px-4 py-3">{e.address}</td>
            {/* moveInDate / moveOutDate are DATE-only fields (YYYY-MM-DD).
                Use formatDate (parseLocalDate-based) to avoid the UTC
                round-trip that shifts the day in US timezones. */}
            <td className="px-4 py-3">
              {formatDate(e.moveInDate, {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              })}
            </td>
            <td className="px-4 py-3">
              {e.currentResidence
                ? t("housingHistoryTable.present")
                : e.moveOutDate
                  ? formatDate(e.moveOutDate, {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                    })
                  : "-"}
            </td>
            <td className="px-4 py-3">{e.manager}</td>
            <td className="px-4 py-3">{e.phone}</td>
            <td className="px-4 py-3">{e.email}</td>
            <td className="px-4 py-3">
              <button className="rounded-md px-3 py-1.5 text-xs font-medium transition-colors bg-accent text-black hover:bg-accent-hover" onClick={() => onEdit(e)}>
                {t("housingHistoryTable.edit")}
              </button>{" "}
              <button
                className="rounded-md px-3 py-1.5 text-xs font-medium transition-colors text-danger hover:text-red-700"
                onClick={() => onDelete(e)}
              >
                {t("housingHistoryTable.delete")}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default HousingHistoryTable;
